import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as SeekLogo } from '../assets/seek-logo.svg';
import './login/Login.css';
import './LandingPageOne.css';
import { useNavigate } from 'react-router-dom';
import { Mixpanel } from '../analytics/Mixpanel';
import { events_action } from '../analytics/Events';
import { Card } from 'react-bootstrap';
import LandingTitleArrow from '../assets/webp-images/landing-title.png';
import appleIcon from '../assets/new-icons/apple-icon.png';
import playstoreIcon from '../assets/new-icons/playstore-icon.png';
import instaIcon from '../assets/new-icons/insta-icon.png';
import starIcon from '../assets/star.svg';
import { Faqs, LandingFaqs } from '../utils/utils';
import BottomContainer from '../components-v2/buttons/BottomContainer';
import TileGallery from '../components-v2/landing-page/TileGallery';
import { useSelector } from 'react-redux';
import NumberTicker from '../components-v2/number-ticker/NumberTicker';
import challengeServices1 from '../assets/videos/challenge-services-1.mp4';
import challengeServices2 from '../assets/videos/challenge-services-2.mp4';
import classServices1 from '../assets/videos/services-class-1.mp4';
import classServices2 from '../assets/videos/services-class-2.mp4';
import classServices3 from '../assets/videos/services-class-3.mp4';
import courseServices1 from '../assets/videos/services-course-1.mp4';
import courseServices2 from '../assets/videos/services-course-2.mp4';
import courseServices3 from '../assets/videos/services-course-3.mp4';
import gitaServices1 from '../assets/videos/gita-services-1.mp4';
import eventsServices1 from '../assets/videos/events-services-1.mp4';
import personalCoachingServices1 from '../assets/videos/personal-coaching-services-1.mp4';
import planCourse1 from '../assets/webp-images/plan-course-1.png';
import planCourse2 from '../assets/webp-images/plan-course-2.png';
import planCourse3 from '../assets/webp-images/plan-course-3.png';
import planCourse4 from '../assets/webp-images/plan-course-4.png';
import planTestimonial1 from '../assets/webp-images/plan-testimonial-1.png';
import planTestimonial2 from '../assets/webp-images/plan-testimonial-2.png';
import planTestimonial3 from '../assets/webp-images/plan-testimonial-3.png';
import planTestimonial4 from '../assets/webp-images/plan-testimonial-4.png';
import planTestimonial5 from '../assets/webp-images/plan-testimonial-5.png';
import planVideo from '../assets/videos/plan-testimonial.mp4';
import volumeIcon from '../assets/new-icons/volume-icon.png';
import planDesigned1 from '../assets/webp-images/plan-designed-1.png';
import planDesigned2 from '../assets/webp-images/plan-designed-2.png';
import planDesigned3 from '../assets/webp-images/plan-designed-3.png';
import planDesigned4 from '../assets/webp-images/plan-designed-4.png';
import planDesigned5 from '../assets/webp-images/plan-designed-5.png';
import volumeMutedIcon from '../assets/new-icons/volume-muted-icon.png';
import planInstructor1 from '../assets/webp-images/plan-instructor-1.png';
import planInstructor2 from '../assets/webp-images/plan-instructor-2.png';
import planInstructor3 from '../assets/webp-images/plan-instructor-3.png';
import planInstructor4 from '../assets/webp-images/plan-instructor-4.png';
import planInstructor5 from '../assets/webp-images/plan-instructor-5.png';
import planInstructor6 from '../assets/webp-images/plan-instructor-6.png';
import planInstructor7 from '../assets/webp-images/plan-instructor-7.png';
import planInstructor8 from '../assets/webp-images/plan-instructor-8.png';
import planHappyUsers from '../assets/webp-images/plan-happy-users.png';
import planFounders1 from '../assets/webp-images/plan-founders-1.png';
import planFounders2 from '../assets/webp-images/plan-founders-2.png';
import landingPageCta from '../assets/webp-images/landing-page-cta.png';
import landingPageApp1 from '../assets/webp-images/landing-app-screen-1.png';
import landingPageApp2 from '../assets/webp-images/landing-app-screen-2.png';
import landingPageApp3 from '../assets/webp-images/landing-app-screen-3.png';
import landingPageApp4 from '../assets/webp-images/landing-app-screen-4.png';
import landingPageApp5 from '../assets/webp-images/landing-app-screen-5.png';
import PlanScreenAboutItem from './plans/components/PlanScreenAboutItem';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import PlanScreenDesignedItem from './plans/components/PlanScreenDesignedItem';
import FAQ from './plans/components/FAQ';

import './plans/PlanScreen.css';

interface TriggeredEvents {
	[key: string]: boolean;
}

const sectionRanges = {
	// section1: {start: 0, end: 400, section_heading: 'Guided by the Best.'},
	section2: {
		start: 250,
		end: 450,
		section_heading: 'Your everyday partner',
	},
	section3: {
		start: 450,
		end: 750,
		section_heading: 'Number stats',
	},
	section4: {
		start: 750,
		end: 1700,
		section_heading: 'One platform for mental wellness',
	},
	section5: {
		start: 1500,
		end: 1800,
		section_heading: 'Real stories, real impact',
	},
	section8: {
		start: 1700,
		end: 2200,
		section_heading: 'Top 1% seniormost instructors',
	},
	section6: { start: 2250, end: 2700, section_heading: 'Most popular courses' },
	section7: { start: 2900, end: 3200, section_heading: 'App store reviews' },
	section10: {
		start: 3200,
		end: 4000,
		section_heading: 'Designed for people like you',
	},
	section11: { start: 4000, end: 4400, section_heading: 'App screens' },
	section12: { start: 4400, end: 4600, section_heading: 'Meet our founders' },
	// Add other sections as needed
} as { [key: string]: { start: number; end: number; section_heading: string } };

const planAppstoreReviews = [
	{
		rating: 5,
		nameDate: 'Anu Gautam, 02/03/2025',
		title: 'Life-changing app',
		desc: 'I love how flexible the time slots are—it’s so easy to fit meditation into my day. The variety of sessions is amazing!',
	},
	{
		rating: 5,
		nameDate: 'Niyati Verma, 11/02/2025',
		title: 'Best meditation tool',
		desc: 'It is so easy to use! It helped me start meditation and stay consistent. I even overcame my anxiety with Anxiety Release course',
	},
	{
		rating: 5,
		nameDate: 'Parag Sahu, 14/08/2024',
		title: 'Improved my sleep',
		desc: 'After just a few regular sessions, I noticed my sleep has improved so much. Can’t thank this app enough!',
	},
	{
		rating: 5,
		nameDate: 'Karan Mehta, 20/01/2025',
		title: 'A journey to self-discovery',
		desc: 'Each session feels like a new adventure. I’ve learned so much about myself, and it’s helped me grow in ways I never expected.',
	},
	{
		rating: 5,
		nameDate: 'Sonia Patel, 15/09/2024',
		title: 'Stress relief at its best',
		desc: 'This app has been instrumental in managing my stress. The guided meditations are calming and truly effective!',
	},
	{
		rating: 5,
		nameDate: 'Ravi Kumar, 04/02/2024',
		title: 'Enhancing focus and clarity',
		desc: 'I struggled with concentration for years. The focus sessions are a game changer. I feel sharper and more productive!',
	},
];

function LandingPageOne() {
	const navigate = useNavigate();
	const [muted, setMuted] = useState(true);
	const [landingAppIndex, setLandingAppIndex] = useState(0);
	const [readMore, setReadMore] = useState(false);

	const [selectedFAQIndex, setSelectedFAQIndex] = useState<number | null>();
	const [triggeredEvents, setTriggeredEvents] = useState<TriggeredEvents>({
		section1: false,
		section2: false,
		section3: false,
		section4: false,
		section5: false,
		section6: false,
		section7: false,
		section8: false,
		section9: false,
		section10: false,
		section11: false,
		section12: false,
	});

	const videoRef = useRef<HTMLVideoElement>(null);

	const onboardingExperimentKey = useSelector(
		(state: any) => state.abExperiment.data.onboarding_experiment_key
	);

	const markMixPanelEvent = (position: number) => {
		const checkAndTriggerEvent = (
			sectionKey: string,
			start: number,
			end: number
		) => {
			if (
				!triggeredEvents[sectionKey] &&
				position >= start - 10 &&
				position <= end + 10
			) {
				Mixpanel.track('view_section', {
					event_action: 'viewed',
					event_section: sectionKey,
					section_heading: sectionRanges[sectionKey].section_heading,
					event_page: 'landing_page',
				});
				setTriggeredEvents((prevEvents) => ({
					...prevEvents,
					[sectionKey]: true,
				}));
			}
		};

		Object.entries(sectionRanges).forEach(([sectionKey, { start, end }]) => {
			checkAndTriggerEvent(sectionKey, start, end);
		});
	};

	useEffect(() => {
		const handleScroll = () => {
			markMixPanelEvent(window.scrollY);

			if (
				videoRef.current &&
				videoRef.current?.getBoundingClientRect().top < window.innerHeight
			) {
				videoRef.current.play();
			}
		};

		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [triggeredEvents]);

	useEffect(() => {
		const interval = setInterval(() => {
			setLandingAppIndex((prev) => {
				if (prev < 4) {
					return prev + 1;
				} else {
					const elements = document.querySelectorAll(
						`.landing-page-app-top > div > div`
					) as any;

					const images = document.querySelectorAll(
						`.landing-page-app > img`
					) as any;

					[...elements].forEach((element, index) => {
						element.style.transition = 'none';
						element.style.width = '0%';
					});

					[...images].forEach((element, index) => {
						element.style.opacity = '1';
					});

					return 0;
				}
			});
		}, 5000);

		return () => {
			clearInterval(interval);
		};
	}, [landingAppIndex]);

	useEffect(() => {
		const element: HTMLElement | null = document.querySelector(
			`#landing-app-progress-${landingAppIndex + 1} > div`
		);
		const image: HTMLImageElement | null = document.querySelector(
			`#landing-app-${landingAppIndex}`
		);

		if (element) {
			element.style.transition = 'all 3s';
			element.style.width = '100%';
		}

		if (image) {
			image.style.transition = 'all 0.4s';
			image.style.opacity = '0';
		}
	}, [landingAppIndex]);

	useEffect(() => {
		Faqs.splice(10, 2);
		document.body.style.overflowX = 'hidden';
		window.addEventListener(
			'wheel',
			(e) => {
				if (e.deltaX !== 0) {
					e.preventDefault();
				}
			},
			{ passive: false }
		);

		window.addEventListener(
			'touchmove',
			(e) => {
				if (e.touches[0].clientX !== e.touches[0].screenX) {
					e.preventDefault();
				}
			},
			{ passive: false }
		);

		return () => {
			document.body.style.overflowX = 'initial';
			window.removeEventListener('touchmove', (e) => {
				if (e.touches[0].clientX !== e.touches[0].screenX) {
					e.preventDefault();
				}
			});
		};
	}, []);

	useEffect(() => {
		try {
			Mixpanel.track('view_section', {
				event_action: 'viewed',
				section_heading: 'Guided by the Best',
				event_page: 'landing_page',
			});
		} catch (e) {}
	}, []);

	const onFAQClickHandler = (index: number) => {
		try {
			Mixpanel.track('click_faqs_landing_page', {
				event_action: 'clicked',
				faq_question: LandingFaqs[index],
				event_page: 'landing_page',
				event_section: 'FAQs.',
			});
		} catch (e) {}
		setSelectedFAQIndex((prevState) => (prevState === index ? null : index));
	};

	const handleSignUp = async () => {
		try {
			Mixpanel.track('click_get_7_days_free', {
				event_page: 'landing_page',
				event_action: events_action.clicked,
				onboarding_experiment_key: onboardingExperimentKey,
			});
			// navigate('/signup')
			navigate('/onboarding');
		} catch (e) {}
	};

	return (
		<div style={{ paddingBottom: '100px' }} className='login-container'>
			<Card
				style={{
					maxWidth: '400px',
					width: '100%',
					height: '56px',
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					borderBottom: '1px solid #E4E4E4',
					background: '#FFF',
					boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.08)',
					justifyContent: 'space-between',
					borderTop: 'none',
					borderLeft: 'none',
					borderRight: 'none',
				}}>
				<SeekLogo
					style={{ alignSelf: 'center', margin: '16px', marginRight: 'auto' }}
				/>
			</Card>
			<div className={'landing-header'}>
				<div className={'landing-header-title'}>
					<img src={LandingTitleArrow} alt='' />
				</div>
				<TileGallery />
			</div>
			<div style={{ width: '100%', maxWidth: '400px', padding: '0 16px' }}>
				<div className='plan-screen-header-numbers'>
					<div className='plan-screen-header-numbers-item'>
						<p className='plan-screen-header-numbers-item-number'>
							<NumberTicker value={10} />
							K+
						</p>
						<p className='plan-screen-header-numbers-item-text'>Members</p>
					</div>
					<div className='plan-screen-header-numbers-item'>
						<p
							style={{ color: '#FAA53D' }}
							className='plan-screen-header-numbers-item-number'>
							<NumberTicker value={20} />+
						</p>
						<p className='plan-screen-header-numbers-item-text'>
							Meditation styles
						</p>
					</div>
					<div className='plan-screen-header-numbers-item'>
						<p className='plan-screen-header-numbers-item-number'>
							<NumberTicker value={10} />+
						</p>
						<p className='plan-screen-header-numbers-item-text'>Countries</p>
					</div>
				</div>
				<div className='plan-screen-header-numbers'>
					<div className='plan-screen-header-numbers-item'>
						<div className='plan-screen-header-numbers-item-icons'>
							<img src={appleIcon} alt='' />
							<img src={playstoreIcon} alt='' />
						</div>
						<p
							style={{ color: '#FAA53D' }}
							className='plan-screen-header-numbers-item-number'>
							<NumberTicker value={4.8} decimalPlaces={1} />{' '}
							<img src={starIcon} alt='' />
						</p>
						<p className='plan-screen-header-numbers-item-text'>
							App/Play store rating
						</p>
					</div>
					<div className='plan-screen-header-numbers-item'>
						<div className='plan-screen-header-numbers-item-icons'>
							<img src={instaIcon} alt='' />
						</div>
						<p className='plan-screen-header-numbers-item-number'>
							<NumberTicker value={15} />
							K+
						</p>
						<p className='plan-screen-header-numbers-item-text'>
							Instagram followers
						</p>
					</div>
				</div>
			</div>
			<div
				style={{
					width: '100%',
					marginTop: '16px',
					maxWidth: '400px',
					padding: '0 16px',
					textAlign: 'left',
				}}>
				<p className='plan-screen-title'>
					One platform for
					<br />
					<span>mental wellness</span>
				</p>

				<PlanScreenAboutItem
					title='Seek Daily Classes'
					videos={[classServices1, classServices1, classServices1]}
					list={[
						'Designed for consistency',
						'30 minute meditation & yoga classes — anytime',
						'New themes of meditation everyday',
					]}
				/>
				<PlanScreenAboutItem
					title='Seek Special Courses'
					videos={[courseServices1, courseServices2, courseServices3]}
					list={[
						'Courses for sleep, anxiety, gut, anger and more',
						'Lifelong tools backed by science',
						'Learn and share with a supportive cohort',
					]}
				/>
				<PlanScreenAboutItem
					title='21 day Silence Challenge'
					videos={[challengeServices2, challengeServices2, challengeServices2]}
					list={[
						'Start with 1 minute of meditation on Day 1',
						'Learn basics to build the foundation',
						'Reach 21 minutes of meditation on Day 21',
					]}
				/>
				<PlanScreenAboutItem
					title='Daily Gita'
					videos={[gitaServices1, gitaServices1, gitaServices1]}
					list={[
						'Begin your day with sacred insights from the Gita',
						'Understand timeless wisdom in simple words',
						'Move closer to inner clarity, one step at a time',
					]}
				/>
				<PlanScreenAboutItem
					title='Events and Retreats'
					videos={[eventsServices1, eventsServices1, eventsServices1]}
					list={[
						'Live sessions on powerful wellness topics like balancing chakras, breathwork, journaling etc',
						'Experience transformation through online events & offline retreats',
						'Fresh sessions on diverse themes.',
					]}
				/>
				<PlanScreenAboutItem
					title='1:1 Personal Coaching'
					videos={[
						personalCoachingServices1,
						personalCoachingServices1,
						personalCoachingServices1,
					]}
					list={[
						'With top 1% instructors in wellness & self-growth',
						'Flexible sessions tailored to your pace and needs',
						'Get deep guidance from experts',
					]}
				/>
			</div>

			<div
				style={{
					width: '100%',
					marginTop: '16px',
					maxWidth: '400px',
					padding: '0 16px',
					textAlign: 'left',
				}}>
				<p className='plan-screen-title'>
					Real stories,
					<span> real impact</span>
				</p>
				<Swiper
					spaceBetween={10}
					slidesPerView={1.2}
					loop={true}
					speed={600}
					autoplay={{
						delay: 3000,
						disableOnInteraction: true,
					}}
					modules={[Autoplay]}
					className='plan-screen-header-testimonials-swiper'>
					<SwiperSlide className='plan-screen-header-testimonials-swiper-slide'>
						<img src={planTestimonial1} alt='' />
					</SwiperSlide>
					<SwiperSlide className='plan-screen-header-testimonials-swiper-slide'>
						<img src={planTestimonial2} alt='' />
					</SwiperSlide>
					<SwiperSlide className='plan-screen-header-testimonials-swiper-slide'>
						<img src={planTestimonial3} alt='' />
					</SwiperSlide>
					<SwiperSlide className='plan-screen-header-testimonials-swiper-slide'>
						<img src={planTestimonial4} alt='' />
					</SwiperSlide>
					<SwiperSlide className='plan-screen-header-testimonials-swiper-slide'>
						<img src={planTestimonial5} alt='' />
					</SwiperSlide>
				</Swiper>
				<div
					style={{
						marginBottom: 0,
						width: '100%',
						maxWidth: '400px',
					}}
					className='plan-screen-video'>
					<video
						ref={videoRef}
						style={{ width: '100%', borderRadius: '12px' }}
						playsInline
						loop
						muted={muted}
						src={planVideo}></video>
					<div
						onClick={() => {
							Mixpanel.track('click_mute_unmute_testimonial_video', {
								event_action: 'clicked',
								next_state: muted ? 'unmute' : 'mute',
								event_page: 'plan_landing_page',
							});
							setMuted(!muted);
						}}>
						<img src={muted ? volumeMutedIcon : volumeIcon} alt='' />
					</div>
				</div>
				<div
					style={{
						width: '100%',
						maxWidth: '400px',
					}}
					className='plan-screen-header-stats'>
					<div className='plan-screen-header-stats-item'>
						<p
							style={{ marginBottom: '8px' }}
							className='plan-screen-header-stats-item-number'>
							80%
						</p>
						<p
							style={{ marginBottom: '0px' }}
							className='plan-screen-header-stats-item-text'>
							experienced uninterrupted <span>deep sleep</span>
						</p>
					</div>
					<div className='plan-screen-header-stats-item'>
						<p
							style={{ marginBottom: '8px' }}
							className='plan-screen-header-stats-item-number'>
							90%
						</p>
						<p
							style={{ marginBottom: '0px' }}
							className='plan-screen-header-stats-item-text'>
							experienced decrease in <span>anxiety level</span>
						</p>
					</div>
					<div className='plan-screen-header-stats-item'>
						<p
							style={{ marginBottom: '8px' }}
							className='plan-screen-header-stats-item-number'>
							85%
						</p>
						<p
							style={{ marginBottom: '0px' }}
							className='plan-screen-header-stats-item-text'>
							experienced reduced <span>chronic pain</span>
						</p>
					</div>
				</div>
				<div
					style={{
						width: '100%',
						marginTop: '24px',
						maxWidth: '400px',
					}}
					className='plan-screen-instructors'>
					<p className='plan-screen-title'>
						Top <span>1% seniormost</span>
						<br />
						instructors for you
					</p>
					<Swiper
						spaceBetween={10}
						slidesPerView={1.5}
						centeredSlides
						loop={true}
						speed={3000}
						freeMode={true}
						modules={[Autoplay]}
						autoplay={{
							delay: 0,
							disableOnInteraction: false,
						}}
						className='plan-screen-instructors-swiper'>
						<SwiperSlide className='plan-screen-instructors-swiper-slide'>
							<img src={planInstructor1} alt='' />
						</SwiperSlide>
						<SwiperSlide className='plan-screen-instructors-swiper-slide'>
							<img src={planInstructor2} alt='' />
						</SwiperSlide>
						<SwiperSlide className='plan-screen-instructors-swiper-slide'>
							<img src={planInstructor3} alt='' />
						</SwiperSlide>
						<SwiperSlide className='plan-screen-instructors-swiper-slide'>
							<img src={planInstructor4} alt='' />
						</SwiperSlide>
						<SwiperSlide className='plan-screen-instructors-swiper-slide'>
							<img src={planInstructor5} alt='' />
						</SwiperSlide>
						<SwiperSlide className='plan-screen-instructors-swiper-slide'>
							<img src={planInstructor6} alt='' />
						</SwiperSlide>
						<SwiperSlide className='plan-screen-instructors-swiper-slide'>
							<img src={planInstructor7} alt='' />
						</SwiperSlide>
						<SwiperSlide className='plan-screen-instructors-swiper-slide'>
							<img src={planInstructor8} alt='' />
						</SwiperSlide>
					</Swiper>
				</div>
				<div
					style={{
						width: '100%',
						marginTop: '48px',
						maxWidth: '400px',
					}}
					className='plan-screen-courses'>
					<p className='plan-screen-title'>
						Most <span>popular</span> courses
					</p>
					<Swiper
						spaceBetween={10}
						slidesPerView={1.25}
						centeredSlides
						loop={true}
						speed={3000}
						modules={[Autoplay]}
						style={{ marginTop: '24px' }}
						autoplay={{
							delay: 0,
							disableOnInteraction: false,
						}}
						className='plan-screen-courses-swiper'>
						<SwiperSlide className='plan-screen-courses-swiper-slide'>
							<img src={planCourse1} alt='' />
						</SwiperSlide>
						<SwiperSlide className='plan-screen-courses-swiper-slide'>
							<img src={planCourse2} alt='' />
						</SwiperSlide>
						<SwiperSlide className='plan-screen-courses-swiper-slide'>
							<img src={planCourse3} alt='' />
						</SwiperSlide>
						<SwiperSlide className='plan-screen-courses-swiper-slide'>
							<img src={planCourse4} alt='' />
						</SwiperSlide>
					</Swiper>
				</div>
				<div
					style={{
						width: '100%',
						marginTop: '48px',
						maxWidth: '400px',
					}}
					className='plan-screen-reviews'>
					<p className='plan-screen-title'>
						App store
						<span> reviews</span>
					</p>
					<Swiper
						spaceBetween={10}
						slidesPerView={1}
						loop={true}
						speed={600}
						autoplay={{
							delay: 3000,
							disableOnInteraction: false,
						}}
						modules={[Autoplay]}
						className='plan-screen-reviews-swiper'>
						{planAppstoreReviews.map((review, index) => {
							return (
								<SwiperSlide
									key={index}
									className='plan-screen-reviews-swiper-slide'>
									<div className='plan-screen-reviews-item'>
										<div className='plan-screen-reviews-item-stars'>
											{Array.from(Array(review.rating).keys()).map(
												(_, index) => {
													return <img key={index} src={starIcon} alt='' />;
												}
											)}
										</div>
										<p className='plan-screen-reviews-item-name'>
											{review.nameDate}
										</p>
										<p
											style={{ marginBottom: '4px' }}
											className='plan-screen-reviews-item-title'>
											{review.title}
										</p>
										<p
											style={{ marginBottom: '0px' }}
											className='plan-screen-reviews-item-desc'>
											{review.desc}
										</p>
									</div>
								</SwiperSlide>
							);
						})}
					</Swiper>
				</div>
				<div className='plan-screen-designed'>
					<p
						style={{ margin: '60px 0 24px', width: '100%', maxWidth: '400px' }}
						className='plan-screen-title'>
						Designed for people <br />
						like
						<span> you</span>
					</p>
					<PlanScreenDesignedItem
						image={planDesigned1}
						title='Working Professionals'
						desc='Learn powerful techniques to switch off from work stress, stop overthinking, and truly enjoy your personal time without feeling guilty.'
					/>
					<PlanScreenDesignedItem
						image={planDesigned2}
						title='Busy Parents'
						desc='Discover simple yet effective practices to help you create balance, prioritize self-care, and be fully present for your loved ones.'
					/>
					<PlanScreenDesignedItem
						image={planDesigned3}
						title='Chronic health sufferer'
						desc='Explore tailored practices designed to ease discomfort, support your healing process through scientifically-backed meditative practices.'
					/>
					<PlanScreenDesignedItem
						image={planDesigned4}
						title='Spiritual Seekers'
						desc='Engage in guided practices that help you cultivate mindfulness, reach inner peace, and unlock a deeper sense of connection to your true self.'
					/>
					<PlanScreenDesignedItem
						image={planDesigned5}
						title='Fitness Enthusiasts'
						desc='Learn techniques to speed up recovery, boost strength, and stay consistent on your fitness journey by combining meditation with your fitness routine.'
					/>
				</div>

				<div
					style={{
						width: '100%',
						marginLeft: '0',
						maxWidth: '400px',
						marginTop: '24px',
						background: 'transparent',
					}}
					className='plan-screen-users'>
					<img src={planHappyUsers} alt='' />
				</div>
				<div
					style={{
						width: '100%',
						maxWidth: '400px',
						marginTop: '24px',
						background: 'transparent',
					}}
					className='landing-page-app'>
					<div className='landing-page-app-top'>
						<div id='landing-app-progress-1'>
							<div></div>
						</div>
						<div id='landing-app-progress-2'>
							<div></div>
						</div>
						<div id='landing-app-progress-3'>
							<div></div>
						</div>
						<div id='landing-app-progress-4'>
							<div></div>
						</div>
						<div id='landing-app-progress-5'>
							<div></div>
						</div>
					</div>
					<img id='landing-app-5' src={landingPageApp5} alt=''></img>
					<img id='landing-app-4' src={landingPageApp4} alt=''></img>
					<img id='landing-app-3' src={landingPageApp3} alt=''></img>
					<img id='landing-app-2' src={landingPageApp2} alt=''></img>
					<img id='landing-app-1' src={landingPageApp1} alt=''></img>
				</div>
				<div
					style={{
						width: '100%',
						maxWidth: '400px',
						marginTop: '48px',
					}}
					className='plan-screen-founders'>
					<div
						style={{ top: '-230%' }}
						className='plan-screen-founders-bg'></div>
					<p className='plan-screen-title'>
						Meet our <span>founders</span>
					</p>
					<Swiper
						spaceBetween={10}
						slidesPerView={1.2}
						loop={true}
						speed={600}
						autoplay={{
							delay: 3000,
							disableOnInteraction: true,
						}}
						modules={[Autoplay]}
						className='plan-screen-founders-swiper'>
						{Array.from(Array(20).keys()).map((_, index) => {
							return (
								<>
									<SwiperSlide
										key={index}
										className='plan-screen-founders-swiper-slide'>
										<img src={planFounders1} alt='' />
									</SwiperSlide>
									<SwiperSlide
										key={index + 100}
										className='plan-screen-founders-swiper-slide'>
										<img src={planFounders2} alt='' />
									</SwiperSlide>
								</>
							);
						})}
					</Swiper>
				</div>
				{window.innerWidth < 600 && (
					<div
						onClick={() => {
							Mixpanel.track('click_download_app_landing_page', {
								event_action: 'clicked',
								event_page: 'landing_page',
							});
							window.open('https://link.seekdaily.live/download-app', '_blank');
						}}
						style={{
							width: '100%',
							maxWidth: '400px',
							marginTop: '48px',
						}}>
						<img style={{ width: '100%' }} src={landingPageCta} alt='' />
					</div>
				)}
				<div style={{ marginTop: '36px' }} className='plan-screen-faqs'>
					<p className='plan-screen-title'>FAQs</p>
					{Faqs.map((faq, index) => (
						<FAQ
							key={index}
							newPlan
							onetime
							selectedIndex={selectedFAQIndex}
							index={index}
							item={faq}
							onClickHandler={onFAQClickHandler}
						/>
					))}
				</div>
			</div>

			<BottomContainer
				onButtonClick={handleSignUp}
				text={'Become a part of 10K+ Seekers.'}
				label='Start Now'
			/>
		</div>
	);
}

export default LandingPageOne;
